var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"nuxt-error pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-0",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-0"},[_c(_vm.errorPage,{tag:"component",attrs:{"error":_vm.error}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }